<template>
  <div class="side-search">
    <div class="input-search">
      <div class="icon search"></div>
      <div>{{search.title}}</div>
    </div>
    <div class="select-container">
      <v-select v-model="search.query.businessUnit" :options="businessUnits" :clearable="false"></v-select>
    </div>
    <div >
      <div class="modeRadio">
        <div class="bulle-info" @click="toggle"></div>
        <div class="bulle" v-show="show">
          <div class="bulle-text">
            <p v-html="$t('sideSearch.modeExplanation')"></p>
          </div>
        </div>
        <input type="radio" v-model="search.query.mode" :id="'radioProfile'+search.rowId" value="profile" />
        <label :for="'radioProfile'+search.rowId">{{$t('sideSearch.radioProfileLabel')}}</label>
        <input type="radio" v-model="search.query.mode" :id="'radioTicket'+search.rowId" value="ticket" />
        <label :for="'radioTicket'+search.rowId">{{$t('sideSearch.radioTicketLabel')}}</label>
        <!--input type="radio" v-model="search.query.mode" :id="'radioDetails'+search.rowId" value="details" />
        <label :for="'radioDetails'+search.rowId">{{$t('sideSearch.radioDetailsLabel')}}</label-->
      </div>
    </div>
    <div class="cross-place">
      <div class="date-container">
        <div class="pre-datetime">
          <div class="icon calendrier"></div>
          <div class="text">{{$t('sideSearch.from')}}</div>
        </div>
        <datetime class="from" format="dd/MM/yyyy" v-model="search.query.period.startDate" :phrases="{}" placeholder="..." :auto=true value-zone="local" zone="local"></datetime>
      </div>
      <div class="icon cross" @click="removeDateFrom" v-show="search.query.period.startDate"></div>
    </div>
    <div class="cross-place">
      <div class="date-container">
        <div class="pre-datetime">
          <div class="icon calendrier"></div>
          <div class="text">{{$t('sideSearch.until')}}</div>
        </div>
        <datetime class="to" format="dd/MM/yyyy" v-model="search.query.period.endDate" :phrases="{}" placeholder="..." :auto=true value-zone="local" zone="local"></datetime>
      </div>
      <div class="icon cross" @click="removeDateTo" v-show="search.query.period.endDate"></div>
    </div>
    <div class="filters">
      <h6>{{$t('sideSearch.filtersList')}}</h6>
      <div class="add-filter" @click="addFilter">
        <div class="icon plus"></div>
        <div class="add-filter-anchor">{{$t('sideSearch.addFilter')}}</div>
      </div>
      <div class="filter" v-for="(f, findex) in search.query.filters" :key="findex">
        <div>
          <toggle-button :sync="true" v-model="search.query.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" v-if="findex != 0 && search.query.filters.length > 1" />
        </div>
        <div class="input-search filter-name">
          <div>{{$t('sideSearch.filter')}} {{findex + 1}}</div>
          <div class="icon arrow-down"></div>
        </div>
        <!-- div class="filter-title" v-show="checkHasTrueValue(f.general)">Critères généraux</div -->

        <div v-for="(categorie, cindex) in f.general" :key="cindex" v-show="categorie.value">
          <div class="categorie">
            {{categorie.name}}  {{categorie.brand && categorie.brand.name ? '(' + categorie.brand.name + ')' : ''}}
            <div class="remove" @click="removeCategorieFromFilter('general', findex, cindex)">
              <div class="icon cross"></div>
            </div>
          </div>
          <div class="categorie-filter-array">
            <div v-for="(item, iindex) in categorie.filtersArray" :key="iindex"  v-bind:index="iindex">
              <div class="categorie-filter" v-show="item.value">
                {{item.name}}
                <div>
                  <toggle-button :sync="true" v-model="categorie.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" v-if="existingValues(categorie.filtersArray, iindex) - 1" v-show="search.query.mode !== 'details'"/>
                </div>
                <div class="remove" @click="removeValueFromFilter('general', findex, cindex, iindex)">
                  <div class="icon cross"></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <toggle-button :sync="true" v-model="f.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" v-if="isLastCategory(f, cindex)"/>
          </div>
        </div>

        <!-- div class="filter-title" v-show="checkHasTrueValue(f.clients)">Critères Clients</div-->
        <div v-for="(categorie, cindex) in f.clients" :key="cindex" v-show="categorie.value">
          <div class="categorie">
            {{categorie.name}}
            <div class="remove" @click="removeCategorieFromFilter('clients', findex, cindex)">
              <div class="icon cross"></div>
            </div>
          </div>
          <div v-for="(item, iindex) in categorie.filters" :key="iindex">
            <div class="categorie-filter" v-show="item.value">
              {{item.name}} {{item.operator }} {{ typeof item.value === "boolean" ? '' :  item.value}}
              <div class="remove" @click="removeValueFromFilter('clients', findex, cindex, iindex)">
                <div class="icon cross"></div>
              </div>
            </div>
          </div>

          <div v-for="(item, iindex) in categorie.filtersArray" :key="iindex">
            <div class="categorie-filter" v-show="item.value">
              {{item.name}}
              <div>
                <toggle-button :sync="true" v-model="categorie.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" v-if="!isLastValue(categorie.filtersArray, item.name)" />
              </div>
              <div class="remove" @click="removeValueFromFilter('clients', findex, cindex, iindex)">
                <div class="icon cross"></div>
              </div>
            </div>
          </div>
          <div>
            <toggle-button :sync="true" v-model="f.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" v-if="isLastCategory(f, cindex)" />
          </div>
        </div>
        <div class="filter-title" v-show="checkHasTrueValue(f.imported)">{{$t('sideSearch.importedCSVData')}}</div>
        <div v-for="(categorie, cindex) in f.imported" :key="cindex" v-show="categorie.value">
          <div class="categorie">
            {{cindex}} ({{categorie.data.length}} {{$t('sideSearch.items')}})
            <toggle-button :sync="true" v-model="categorie.operator" :labels="{checked: $t('and'), unchecked: $t('or')}" :width="toggleWidth" />
            <div class="remove" @click="removeCategorieFromFilter('clients', findex, cindex)">
              <div class="icon cross"></div>
            </div>
          </div>
          <div v-for="(item, iindex) in categorie.filters" :key="iindex">
            <div class="categorie-filter" v-show="item.value">
              {{item.name}}
              <div class="remove" @click="removeValueFromFilter('clients', findex, cindex, iindex)">
                <div class="icon cross"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="input-search filter-name" @click="removeFilter(findex)">
          <div>{{$t('sideSearch.deleteFilter')}}</div>
          <div class="icon delete"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: {
    search: Object, 
    businessUnits: Array
  },
  components: {
    ToggleButton
  },
  data() {
    return {
      from: null,
      to: null,
      filters: [], 
      toggleWidth: 50, 
      show: false
    }
  },
  created() {
    if (!this.search.query.businessUnit) {
      this.search.query.businessUnit = this.businessUnits[0]
    }
    if(!this.search.query.mode) {
      this.search.query.mode = "profile"
    }
  },
  methods: {
    isLastValue(obj, index) {
      //if(!obj) return false
      let result = []
      let keys = Object.keys(obj)
      keys.forEach(function(key){
        result.push(obj[key])
      })
      let res = result.filter(el => el.value)
      let test = res[res.length - 1]
      return test ? test.name === index : false
    },
    existingValues(array, index) {
      let lastIndex
      array.forEach((el, index) => {
        if (el.value) {
          lastIndex = index
        }
      })
      return lastIndex == index
    },
    isLastCategory(f, cat) {
      const generalFilter = Object.keys(f.general).filter(el => f.general[el].value)
      const clientsFilter = Object.keys(f.clients).filter(el => f.clients[el].value)
      const totalFilter = generalFilter.concat(clientsFilter)
      return totalFilter.indexOf(cat) != totalFilter.length - 1
    },
    checkHasTrueValue(categories) {
      for (let g in categories) {
        if (categories[g].value == true) return true
      }
      return false
    },
    addFilter() {
      this.$emit('addFilter', this.search.rowId)
    },
    removeFilter(findex) {
      this.$emit('removeFilter', this.search.rowId,findex)
    },
    removeCategorieFromFilter(type, findex, cindex) {
      this.$emit('removeCategorie', this.search.rowId, type, findex, cindex)
    },
    removeValueFromFilter(type, findex, cindex, iindex) {
      this.$emit('removeValue', this.search.rowId, type, findex, cindex, iindex)
    },
    removeDateFrom() {
      this.search.query.period.startDate = null
    },
    removeDateTo() {
      this.search.query.period.endDate = null
    },
    businessUnitChanged() {
      console.log("Business unit= " + this.search.query.businessUnit)

    },
    toggle(event){
      const rect = this.$el.getElementsByClassName("bulle-info")[0].getBoundingClientRect()
      this.$el.getElementsByClassName("bulle")[0].style.top = rect.top + 'px'
      this.show = !this.show
    }
  },
  watch : {
    filters:function(val) {
      console.log(val)
      if(val.length == 0) {
        console.log("array filtre est vide")
      }
    },
    search: {
      handler: function() {
        console.log("Business Unit :" + this.search.query.businessUnit)
        this.$emit('changeBusinessUnit', this.search.query.businessUnit)
      },
      deep: true
    }, 
    show:function(val) {
      let that = this
      if(val == true) {
        window.addEventListener('click', function(event){
          if(event.target.className != 'bulle-info' && !event.target.classList.contains('bulle-text')) {
            that.show = false
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/side_search.sass"
</style>
